import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { hideUnsupportedModal } from '../../actions/folders/actions';
import { FoldersUnsupportedModal } from '../../components/FoldersUnsupportedModal';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import { selectIsFoldersUnsupportedModalOpen } from '../../selectors/folders';
import { useApplicationContext } from '../../utils/applicationContext';

export const FoldersUnsupportedModalContainer = () => {
  const { config } = useApplicationContext();
  const dispatch = useDispatch();
  const isOpenByApp = useSelector(selectIsFoldersUnsupportedModalOpen);
  const [isHidedByUser, saveModalHideState] = useLocalStorage('isFolderUnsupportedModalHide', false);
  const isHiddenByConfig = config.get('favorites-frontend.isFolderUnsupportedModalHidden') || false;

  // by app - это когда мы зашли на страницу подборки, в таком случае мы точно показываем модалку
  // by user - это когда юзер закрыл модалку в этой или прошлой сессии
  // by config - фиче-тоггл, который полностью включает/отключает функционал
  const isOpen = (isOpenByApp || !isHidedByUser) && !isHiddenByConfig;

  const handleModalClose = React.useCallback(() => {
    saveModalHideState(true);
    dispatch(hideUnsupportedModal());
  }, [saveModalHideState, dispatch]);

  return <FoldersUnsupportedModal isOpen={isOpen} onClose={handleModalClose} />;
};
